/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  BusinessMemory,
  BusinessMemory$inboundSchema,
} from "./businessmemory.js";

export type SearchBusinessMemoriesResponseBody = {
  memories: Array<BusinessMemory>;
};

/** @internal */
export const SearchBusinessMemoriesResponseBody$inboundSchema: z.ZodMiniType<
  SearchBusinessMemoriesResponseBody,
  unknown
> = z.object({
  memories: z.array(BusinessMemory$inboundSchema),
});

export function searchBusinessMemoriesResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<SearchBusinessMemoriesResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      SearchBusinessMemoriesResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SearchBusinessMemoriesResponseBody' from JSON`,
  );
}
